<form>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fal fa-cloud-upload"></i> Import Guests from vCard Files
    </h5>
    <button (click)="close()"
            type="button"
            class="close">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body">
    <div ng2FileDrop
         [uploader]="uploader"
         class="upload-box">
      <h5>
        Drop files here or <a  href="javascript:;" (click)="fileInput.click()"
                               matTooltip="Only vcf files smaller than 5MB are allowed"
                               matTooltipPosition="above"
                               matTooltipClass="text-center"
                               class="upload-button">
        click
      </a> to upload
        <input type="file"
               [accept]="acceptFileExtensions"
               #fileInput
               ng2FileSelect
               [uploader]="uploader"
               multiple class="d-none">
      </h5>
    </div>
    <div class="upload-guide">
      <h5 [innerHtml]="guide?.description"></h5>
      <ul>
        <li *ngFor="let item of guide?.list" [innerHtml]="item"></li>
      </ul>
      <a href="javascript:;" (click)="downloadSample()">Download sample vCard</a>
    </div>
    <mat-accordion>
      <mat-expansion-panel *ngFor="let file of files; let i = index;">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{file.file.name | truncate:30}}
            <small>(<i class="fal fa-hand-point-up"></i> Preview)</small>
          </mat-panel-title>
          <mat-panel-description>
            <span class="icon-container"
                  [ngClass]="{'text-danger': file.isError, hidden:!file.isError}"
                  [matTooltip]="getFileErrorText(file)"
                  matTooltipPosition="above"
                  matTooltipClass="text-left pre-line">
              <i class="fal fa-exclamation-square"></i>
            </span>
            <span class="text-danger icon-container remove"
                  (click)="onRemoveFile(file, i)"
                  matTooltip="Remove file"
                  matTooltipPosition="above"
                  matTooltipClass="text-left pre-line">
              <i class="fal fa-trash-alt"></i>
            </span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="table-responsive" *ngIf="file.items">
          <table class="table table-condensed" aria-hidden="false">
            <thead>
              <tr>
                <th class="icon"></th>
                <th *ngFor="let col of columnDefs" [style.width]="col.width"> {{col.label}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of file.items">
                <td class="icon">
                <span class="icon-container"
                      [ngClass]="{'text-warning':!item.isError && item.isWarning, 'text-danger':item.isError }"
                      [matTooltip]="getItemErrorText(item)"
                      matTooltipPosition="above"
                      matTooltipClass="text-left pre-line">
                  <i class="fal fa-exclamation-triangle"
                     [ngClass]="{'fa-exclamation-triangle':!item.isError && item.isWarning, 'fa-exclamation-square':item.isError }"></i>
                </span>
                </td>
                <td *ngFor="let col of columnDefs; let i = index">
                  {{item.item | fieldOrPath: col.field}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div class="modal-footer">
    <button (click)="close()"
            type="button"
            class="btn btn-outline btn-default-outline text-uppercase">
      <i class="fal fa-times"></i> cancel
    </button>
    <button (click)="create()"
            [disabled]="!files?.length"
            type="button"
            class="btn btn-success text-uppercase create-btn">
      <i class="fal fa-cloud-upload"></i> upload
    </button>
  </div>
</form>
